import { Input, Select, Typography } from 'antd';
import { useTranslation } from 'react-i18next';

import styles from './phoneInput.module.scss';

const { Option } = Select;

interface PhoneViewProps {
	dialCode?: string;
	phoneNumber?: string;
	label?: string;
	labeled?: boolean; // to show or hide label
	fullWidth?: boolean;
}

function PhoneViewComponent({ dialCode, phoneNumber, label, labeled = true, fullWidth }: PhoneViewProps) {
	const { t } = useTranslation();

	const displayDialCode = dialCode ? (dialCode.startsWith('+') ? dialCode : '+' + dialCode) : '';

	const selectBefore = (
		<Select size="middle" value={displayDialCode} className={styles.select_element} disabled>
			<Option value={displayDialCode} key={displayDialCode} className="mb-1">
				<span style={{ direction: 'ltr', display: 'block', fontWeight: 500, color: '#555' }}>{displayDialCode}</span>
			</Option>
		</Select>
	);

	return (
		<>
			{labeled && (
				<Typography.Text className="d-block" style={{ marginBottom: 5, fontSize: 15 }}>
					{label || t('COMMON.PHONE_NUMBER')}
				</Typography.Text>
			)}

			<Input
				addonBefore={selectBefore}
				className={`${styles.phoneInput} phoneInput`}
				type="text"
				disabled
				value={phoneNumber}
				style={{ direction: 'ltr', maxWidth: '100%', width: fullWidth ? '100%' : 'var(--inputWidth)' }}
			/>
		</>
	);
}

export default PhoneViewComponent;
